import './UserInfo.scss';

import undefinedAvatar from '../../assets/images/undefined-avatar.svg';
import { Avatar } from 'primereact/avatar';
import { useEffect, useState } from 'react';
import { UserService } from '../../service/UserService';
import { useAuth } from '../../hook/useAuth';

const UserInfo = ({}) => {
  const { profile } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    const avatarUrl = UserService.getAvatarUrl(profile);
    setAvatarUrl(avatarUrl);
    setUserName(profile.name);
  }, [profile]);

    return (
        <div className="user-info">
          <div className="image-wrapper">
            <Avatar image={avatarUrl} shape="circle" icon="pi pi-user" className="image" />
          </div>
          <div className="label">{userName}</div>
        </div>
    )
}

export default UserInfo;